import React, { Component } from 'react'
import styles from './ToggleSwitch.module.css'

export default class ToggleSwitch extends Component {
    isDisabled = () => {
        if (typeof this.props.disabled === 'boolean') {
            return this.props.disabled
        }

        return false
    }

    render() {
        return (
            <label 
                className={`${styles['toggle-switch']} ${this.props.checked ? styles['toggle-switch-active'] : ''}`} 
                htmlFor={this.props.id}
            >
                <input 
                    className="checkbox" 
                    type="checkbox" 
                    id={this.props.id} 
                    value={this.props.value} 
                    onChange={this.props.onChange} 
                    name={this.props.name}
                    defaultChecked={this.props.defaultChecked} 
                    checked={this.isDisabled() ? false : this.props.checked}
                    disabled={this.isDisabled()}
                />
                <div></div>
            </label>
        )
    }
}
